// extracted by mini-css-extract-plugin
export default {"notifications":"email-settings-panel_notifications__66udQ","access-options-content":"email-settings-panel_access-options-content__dMgCu"};